import React, { useState } from "react";
import { Box, Drawer } from "@mui/material";
import CollapsibleSidebar from "./navBar/Sidebar";
import BarraDeNavegacion from "./navBar/barraDeNavegacion";
import ProfessionalHistoryPC from "../../navbar/navVers03/ProfessionalHistoryPC";
import { useSystems } from "../../../context/SystemContext";

const DashboardLayout = ({ children, disablePadding = false, hideSidebar = false }) => {
  const { showHistory, setHistoryVisible } = useSystems();
  // Estado para controlar la apertura del menú en móvil
  const [mobileOpen, setMobileOpen] = useState(false);

  // Función para alternar el estado del menú lateral
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawerWidth = 240; // Ancho que tendrá el menú en el celular

  return (
    <Box 
      sx={{ 
        display: "flex", 
        flexDirection: "column", 
        height: "100vh", 
        width: "100vw",
        backgroundColor: "#fff",
        overflow: "hidden",
        zIndex: 100005 
      }}
    >
      {/* ==== NAVBAR SUPERIOR ==== */}
      <Box sx={{ flexShrink: 0, width: "100%", zIndex: 100005 }}>
        {/* Pasamos la función al Navbar para que el botón de hamburguesa funcione */}
        <BarraDeNavegacion onMenuClick={handleDrawerToggle} />
      </Box>

      {/* ==== CONTENEDOR INFERIOR (Sidebar + Contenido) ==== */}
      <Box 
        sx={{ 
          display: "flex", 
          flexDirection: "row", 
          flexGrow: 1, 
          overflow: "hidden",
          position: "relative"
        }}
      >
        {/* --- SIDEBAR PARA MÓVIL (DRAWER) --- */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            zIndex: 100010, // Muy alto para estar por encima del SystemIframeContainer
            "& .MuiDrawer-paper": { 
              boxSizing: "border-box", 
              width: drawerWidth,
              border: "none",
              backgroundColor: "white",
              zIndex: 100010
            },
          }}
        >
          {/* Aquí usamos el Sidebar con las props de móvil */}
          <CollapsibleSidebar isMobile={true} onClose={handleDrawerToggle} />
        </Drawer>

        {/* --- SIDEBAR PARA ESCRITORIO --- */}
        {!hideSidebar && (
          <Box 
            sx={{ 
              display: { xs: "none", md: "block" }, // Se oculta en móvil
              flexShrink: 0, 
              height: "100%", 
              borderRight: '1px solid #f0f0f0' 
            }}
          >
            <CollapsibleSidebar />
          </Box>
        )}
        {/* --- CONTENIDO PRINCIPAL SCROLLEABLE --- */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: "100%",
            overflowY: "auto", 
            backgroundColor: "#fff",
            px: disablePadding ? 0 : { xs: 2, md: 4 },
            py: disablePadding ? 0 : 3,
            transition: "padding 0.3s ease",
            position: "relative"
          }}
        >
          {showHistory ? (
            <ProfessionalHistoryPC onClose={() => setHistoryVisible(false)} />
          ) : (
            children
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;